import {
  Companion_getInstancefq4vwlyjorqo as Companion_getInstance,
  Type_ClientTermsAndConditions_getInstance2f0qgbe5c0m6j as Type_ClientTermsAndConditions_getInstance,
  CrowPayLegalDocumentvhqnf9xycsrg as CrowPayLegalDocument,
  Typeqwc7utefu20x as Type,
} from './databaseModels.mjs';
import {
  properties1qnxlk10mmfrs as properties,
  get_serializableAnnotations132wwdaanmitj as get_serializableAnnotations,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../../../lightning-server-shared/com/lightningkite/serialization/SerializableProperty.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { Companion_instance1i4n4o7mef2za as Companion_instance } from '../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Clock.mjs';
import { get_default1l68fybpthpme as get_default } from '../../../lightning-server-shared/com/lightningkite/DefaultClock.mjs';
import { Instant3cn81rq2kpflk as Instant } from '../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Instant.mjs';
import {
  Companion_getInstance3n9as6ds1py67 as Companion_getInstance_0,
  UUID21wrnrlmk5y1y as UUID,
} from '../../../lightning-server-shared/com/lightningkite/UUID.js.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_type(_this__u8e3s4) {
  return _this__u8e3s4.prop(CrowPayLegalDocument_type_getInstance());
}
function get_establishedAt(_this__u8e3s4) {
  return _this__u8e3s4.prop(CrowPayLegalDocument_establishedAt_getInstance());
}
function prepareCrowPayLegalDocumentFields() {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var props = [CrowPayLegalDocument__id_getInstance(), CrowPayLegalDocument_type_getInstance(), CrowPayLegalDocument_establishedAt_getInstance(), CrowPayLegalDocument_contents_getInstance(), CrowPayLegalDocument_version_getInstance()];
  var tmp = Companion_getInstance().k2a();
  properties(tmp, (it) => props);
}
function CrowPayLegalDocument_type$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(1);
}
function CrowPayLegalDocument_type$_get_name_$ref_ojx283() {
  return (p0) => p0.i20();
}
function CrowPayLegalDocument_type$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[1];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function CrowPayLegalDocument_type$_get_serializer_$ref_e88pka() {
  return (p0) => p0.h2j();
}
function CrowPayLegalDocument_type$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(1);
}
function CrowPayLegalDocument_type$_get_annotations_$ref_v0ir4i() {
  return (p0) => p0.bz();
}
var CrowPayLegalDocument_typeClass;
function CrowPayLegalDocument_type() {
  if (CrowPayLegalDocument_typeClass === VOID) {
    class $ {
      constructor() {
        CrowPayLegalDocument_type_instance = this;
        var tmp = this;
        tmp.s5u_1 = lazy(CrowPayLegalDocument_type$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.t5u_1 = lazy(CrowPayLegalDocument_type$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.u5u_1 = lazy(CrowPayLegalDocument_type$annotations$delegate$lambda);
        this.v5u_1 = Type_ClientTermsAndConditions_getInstance();
        this.w5u_1 = 'CrowPayLegalDocument.Type.ClientTermsAndConditions';
      }
      i20() {
        var tmp0 = this.s5u_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, CrowPayLegalDocument_type$_get_name_$ref_ojx283(), null);
        return tmp0.f2();
      }
      x5u(receiver) {
        return receiver.z5u_1;
      }
      k2j(receiver) {
        return this.x5u(receiver instanceof CrowPayLegalDocument() ? receiver : THROW_CCE());
      }
      d5v(receiver, value) {
        return receiver.e5v(VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof CrowPayLegalDocument() ? receiver : THROW_CCE();
        return this.d5v(tmp, value instanceof Type() ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.t5u_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, CrowPayLegalDocument_type$_get_serializer_$ref_e88pka(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.u5u_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, CrowPayLegalDocument_type$_get_annotations_$ref_v0ir4i(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'CrowPayLegalDocument_type', VOID, VOID, [SerializableProperty()]);
    CrowPayLegalDocument_typeClass = $;
  }
  return CrowPayLegalDocument_typeClass;
}
var CrowPayLegalDocument_type_instance;
function CrowPayLegalDocument_type_getInstance() {
  if (CrowPayLegalDocument_type_instance === VOID)
    new (CrowPayLegalDocument_type())();
  return CrowPayLegalDocument_type_instance;
}
function CrowPayLegalDocument_establishedAt$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(2);
}
function CrowPayLegalDocument_establishedAt$_get_name_$ref_fav23g() {
  return (p0) => p0.i20();
}
function CrowPayLegalDocument_establishedAt$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[2];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function CrowPayLegalDocument_establishedAt$_get_serializer_$ref_um5shp() {
  return (p0) => p0.h2j();
}
function CrowPayLegalDocument_establishedAt$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(2);
}
function CrowPayLegalDocument_establishedAt$_get_annotations_$ref_9ktr1j() {
  return (p0) => p0.bz();
}
var CrowPayLegalDocument_establishedAtClass;
function CrowPayLegalDocument_establishedAt() {
  if (CrowPayLegalDocument_establishedAtClass === VOID) {
    class $ {
      constructor() {
        CrowPayLegalDocument_establishedAt_instance = this;
        var tmp = this;
        tmp.f5v_1 = lazy(CrowPayLegalDocument_establishedAt$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.g5v_1 = lazy(CrowPayLegalDocument_establishedAt$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.h5v_1 = lazy(CrowPayLegalDocument_establishedAt$annotations$delegate$lambda);
        var tmp_2 = this;
        // Inline function 'com.lightningkite.now' call
        tmp_2.i5v_1 = get_default(Companion_instance).b1m();
        this.j5v_1 = 'now()';
      }
      i20() {
        var tmp0 = this.f5v_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, CrowPayLegalDocument_establishedAt$_get_name_$ref_fav23g(), null);
        return tmp0.f2();
      }
      x5u(receiver) {
        return receiver.a5v_1;
      }
      k2j(receiver) {
        return this.x5u(receiver instanceof CrowPayLegalDocument() ? receiver : THROW_CCE());
      }
      k5v(receiver, value) {
        return receiver.e5v(VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof CrowPayLegalDocument() ? receiver : THROW_CCE();
        return this.k5v(tmp, value instanceof Instant() ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.g5v_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, CrowPayLegalDocument_establishedAt$_get_serializer_$ref_um5shp(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.h5v_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, CrowPayLegalDocument_establishedAt$_get_annotations_$ref_9ktr1j(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'CrowPayLegalDocument_establishedAt', VOID, VOID, [SerializableProperty()]);
    CrowPayLegalDocument_establishedAtClass = $;
  }
  return CrowPayLegalDocument_establishedAtClass;
}
var CrowPayLegalDocument_establishedAt_instance;
function CrowPayLegalDocument_establishedAt_getInstance() {
  if (CrowPayLegalDocument_establishedAt_instance === VOID)
    new (CrowPayLegalDocument_establishedAt())();
  return CrowPayLegalDocument_establishedAt_instance;
}
function CrowPayLegalDocument__id$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(0);
}
function CrowPayLegalDocument__id$_get_name_$ref_utr2mj() {
  return (p0) => p0.i20();
}
function CrowPayLegalDocument__id$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[0];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function CrowPayLegalDocument__id$_get_serializer_$ref_ts40ky() {
  return (p0) => p0.h2j();
}
function CrowPayLegalDocument__id$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(0);
}
function CrowPayLegalDocument__id$_get_annotations_$ref_fwouve() {
  return (p0) => p0.bz();
}
var CrowPayLegalDocument__idClass;
function CrowPayLegalDocument__id() {
  if (CrowPayLegalDocument__idClass === VOID) {
    class $ {
      constructor() {
        CrowPayLegalDocument__id_instance = this;
        var tmp = this;
        tmp.l5v_1 = lazy(CrowPayLegalDocument__id$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.m5v_1 = lazy(CrowPayLegalDocument__id$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.n5v_1 = lazy(CrowPayLegalDocument__id$annotations$delegate$lambda);
        this.o5v_1 = Companion_getInstance_0().k2p();
        this.p5v_1 = 'UUID.random()';
      }
      i20() {
        var tmp0 = this.l5v_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, CrowPayLegalDocument__id$_get_name_$ref_utr2mj(), null);
        return tmp0.f2();
      }
      x5u(receiver) {
        return receiver.y5u_1;
      }
      k2j(receiver) {
        return this.x5u(receiver instanceof CrowPayLegalDocument() ? receiver : THROW_CCE());
      }
      q5v(receiver, value) {
        return receiver.e5v(value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof CrowPayLegalDocument() ? receiver : THROW_CCE();
        return this.q5v(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.m5v_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, CrowPayLegalDocument__id$_get_serializer_$ref_ts40ky(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.n5v_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, CrowPayLegalDocument__id$_get_annotations_$ref_fwouve(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'CrowPayLegalDocument__id', VOID, VOID, [SerializableProperty()]);
    CrowPayLegalDocument__idClass = $;
  }
  return CrowPayLegalDocument__idClass;
}
var CrowPayLegalDocument__id_instance;
function CrowPayLegalDocument__id_getInstance() {
  if (CrowPayLegalDocument__id_instance === VOID)
    new (CrowPayLegalDocument__id())();
  return CrowPayLegalDocument__id_instance;
}
function CrowPayLegalDocument_contents$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(3);
}
function CrowPayLegalDocument_contents$_get_name_$ref_jj6ahp() {
  return (p0) => p0.i20();
}
function CrowPayLegalDocument_contents$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[3];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function CrowPayLegalDocument_contents$_get_serializer_$ref_dpwgxi() {
  return (p0) => p0.h2j();
}
function CrowPayLegalDocument_contents$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(3);
}
function CrowPayLegalDocument_contents$_get_annotations_$ref_gzetiq() {
  return (p0) => p0.bz();
}
var CrowPayLegalDocument_contentsClass;
function CrowPayLegalDocument_contents() {
  if (CrowPayLegalDocument_contentsClass === VOID) {
    class $ {
      constructor() {
        CrowPayLegalDocument_contents_instance = this;
        var tmp = this;
        tmp.r5v_1 = lazy(CrowPayLegalDocument_contents$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.s5v_1 = lazy(CrowPayLegalDocument_contents$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.t5v_1 = lazy(CrowPayLegalDocument_contents$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.r5v_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, CrowPayLegalDocument_contents$_get_name_$ref_jj6ahp(), null);
        return tmp0.f2();
      }
      x5u(receiver) {
        return receiver.b5v_1;
      }
      k2j(receiver) {
        return this.x5u(receiver instanceof CrowPayLegalDocument() ? receiver : THROW_CCE());
      }
      u5v(receiver, value) {
        return receiver.e5v(VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof CrowPayLegalDocument() ? receiver : THROW_CCE();
        return this.u5v(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.s5v_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, CrowPayLegalDocument_contents$_get_serializer_$ref_dpwgxi(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.t5v_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, CrowPayLegalDocument_contents$_get_annotations_$ref_gzetiq(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'CrowPayLegalDocument_contents', VOID, VOID, [SerializableProperty()]);
    CrowPayLegalDocument_contentsClass = $;
  }
  return CrowPayLegalDocument_contentsClass;
}
var CrowPayLegalDocument_contents_instance;
function CrowPayLegalDocument_contents_getInstance() {
  if (CrowPayLegalDocument_contents_instance === VOID)
    new (CrowPayLegalDocument_contents())();
  return CrowPayLegalDocument_contents_instance;
}
function CrowPayLegalDocument_version$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(4);
}
function CrowPayLegalDocument_version$_get_name_$ref_sf52qf() {
  return (p0) => p0.i20();
}
function CrowPayLegalDocument_version$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[4];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function CrowPayLegalDocument_version$_get_serializer_$ref_yfssi8() {
  return (p0) => p0.h2j();
}
function CrowPayLegalDocument_version$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(4);
}
function CrowPayLegalDocument_version$_get_annotations_$ref_i8ssks() {
  return (p0) => p0.bz();
}
var CrowPayLegalDocument_versionClass;
function CrowPayLegalDocument_version() {
  if (CrowPayLegalDocument_versionClass === VOID) {
    class $ {
      constructor() {
        CrowPayLegalDocument_version_instance = this;
        var tmp = this;
        tmp.v5v_1 = lazy(CrowPayLegalDocument_version$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.w5v_1 = lazy(CrowPayLegalDocument_version$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.x5v_1 = lazy(CrowPayLegalDocument_version$annotations$delegate$lambda);
        this.y5v_1 = null;
        this.z5v_1 = 'null';
      }
      i20() {
        var tmp0 = this.v5v_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, CrowPayLegalDocument_version$_get_name_$ref_sf52qf(), null);
        return tmp0.f2();
      }
      x5u(receiver) {
        return receiver.c5v_1;
      }
      k2j(receiver) {
        return this.x5u(receiver instanceof CrowPayLegalDocument() ? receiver : THROW_CCE());
      }
      a5w(receiver, value) {
        return receiver.e5v(VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof CrowPayLegalDocument() ? receiver : THROW_CCE();
        return this.a5w(tmp, (value == null ? true : typeof value === 'string') ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.w5v_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, CrowPayLegalDocument_version$_get_serializer_$ref_yfssi8(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.x5v_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, CrowPayLegalDocument_version$_get_annotations_$ref_i8ssks(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'CrowPayLegalDocument_version', VOID, VOID, [SerializableProperty()]);
    CrowPayLegalDocument_versionClass = $;
  }
  return CrowPayLegalDocument_versionClass;
}
var CrowPayLegalDocument_version_instance;
function CrowPayLegalDocument_version_getInstance() {
  if (CrowPayLegalDocument_version_instance === VOID)
    new (CrowPayLegalDocument_version())();
  return CrowPayLegalDocument_version_instance;
}
//region block: exports
export {
  get_establishedAt as get_establishedAt34uuc9xf75ez9,
  prepareCrowPayLegalDocumentFields as prepareCrowPayLegalDocumentFields3bapu57ipmpnj,
  get_type as get_type2gdsz5zh8ip2m,
};
//endregion

//# sourceMappingURL=CrowPayLegalDocumentFields.mjs.map
